export function formatMonthYear(value?: string | null): string {
	if (!value) return '';
	const d = new Date(value);
	if (Number.isNaN(d.getTime())) return '';
	return `${d.toLocaleString('es-CL', { timeZone: 'UTC', month: 'short' })} ${d.getUTCFullYear()}`;
}

export function formatRange(start?: string | null, end?: string | null, current?: boolean): string {
	const s = formatMonthYear(start);
	const e = formatMonthYear(end);
	if (current) return s ? `${s} – Actual` : 'Actual';
	if (e) return s ? `${s} – ${e}` : e;
	return s;
}

export function yearOf(dateStr: string): string {
	return new Date(dateStr).getUTCFullYear().toString();
}

function toTime(value?: string | null): number {
	if (!value) return Number.NEGATIVE_INFINITY;
	const parsed = Date.parse(`${value}T00:00:00Z`);
	return Number.isNaN(parsed) ? Number.NEGATIVE_INFINITY : parsed;
}

interface DateSortable {
	id: number;
	fechaInicio?: string | null;
	fechaTermino?: string | null;
	enCurso?: boolean | null;
}

/**
 * Replicates the auto-sort criteria used by the date-based edit modals
 * (current first, then most recent end/start date). The auto order is computed,
 * not persisted in ordenVisual, so the view recomputes it to stay in sync.
 */
export function sortCvByDate<T extends DateSortable>(items: T[]): T[] {
	return [...items].sort((a, b) => {
		const aCurrent = a.enCurso ?? !a.fechaTermino;
		const bCurrent = b.enCurso ?? !b.fechaTermino;
		if (aCurrent !== bCurrent) return aCurrent ? -1 : 1;

		const primaryDelta = toTime(b.fechaTermino ?? b.fechaInicio) - toTime(a.fechaTermino ?? a.fechaInicio);
		if (primaryDelta !== 0) return primaryDelta;

		const startDelta = toTime(b.fechaInicio) - toTime(a.fechaInicio);
		if (startDelta !== 0) return startDelta;

		return a.id - b.id;
	});
}
